import initializeKeycloak, {KeycloakInstance} from 'keycloak-js';
import Config from './util/config';
import {jwtDecode} from 'jwt-decode';

const keycloak: KeycloakInstance = initializeKeycloak({
    url: Config.keycloak.baseUrl,
    realm: Config.keycloak.realm,
    clientId: Config.keycloak.clientId,
});

const Keycloak = {
    initialize: (): Promise<void> => new Promise((resolve, reject) => {
        keycloak.init({
            onLoad: 'login-required',
            silentCheckSsoFallback: false,
            checkLoginIframe: false,
        })
            .then(authenticated => authenticated ? resolve() : reject())
            .catch(reason => reject(reason));
    }),
    refreshToken: (minValidity: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            keycloak.updateToken(minValidity)
                .then(() => resolve())
                .catch(() => reject());
        });
    },
    logout: () => keycloak.logout(),
    instance: keycloak,

    /**
     * Automatic login for voting user (Direct Grant)
     */
    loginWithStaticUser: async (
        key: string,
    ): Promise<{ access_token: string, refresh_token: string }> => {
        await keycloak.init({});
        const url = `${Config.keycloak.baseUrl}/realms/${Config.keycloak.realm}/protocol/openid-connect/token`;

        const params = new URLSearchParams();
        params.append('client_id', Config.keycloak.clientId);
        params.append('grant_type', 'password');
        try {
            if (Config.keycloak.staticUser && Config.keycloak.staticUser[key]) {
                params.append('username', Config.keycloak.staticUser[key].username);
                params.append('password', Config.keycloak.staticUser[key].password);
            } else {
                throw new Error(`Static user with key "${key}" not found in configuration.`);
            }
        } catch (error) {
            throw new Error(`Error retrieving static user with key "${key}": ${error.message}`);
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params,
        });

        if (!response.ok) {
            throw new Error(`Failed to login: ${response.statusText}`);
        }

        const tokens = await response.json();
        Keycloak.instance.token = tokens.access_token;
        Keycloak.instance.refreshToken = tokens.refresh_token;

        Keycloak.instance.tokenParsed = jwtDecode(tokens.access_token);
        return tokens;
    },
};

export default Keycloak;
